export const ADDITIONAL_NAME = 'additional';
export const ADS_BEFORE_PROMO_FORM = 5;
export const AD_TYPE_PROMO = 'promo';
export const AIRBAG_NAME = 'airbag';
export const BODY_TYPE_NAME = 'bodyType';
export const CITY_NAME = 'city';
export const COLOR_NAME = 'color';
export const COMFORT_NAME = 'comfort';
export const CONSUMPTION_RANGE_NAME = 'consumptionRange';
export const NOT_DAMAGED_NAME = 'notDamaged';
export const DEFAULT_GEOLOCATION_DISTANCE = 100;
export const DISTANCE_NAME = 'distance';
export const DOOR_RANGE_NAME = 'doorRange';
export const EMISSION_STICKER_NAME = 'emissionSticker';
export const ENGINE_RANGE_NAME = 'engineRange';
export const ENV_STANDARD_NAME = 'envStandard';
export const EXCLUSIVE_NAME = 'exclusive';
export const EXTRAS_NAME = 'extras';
export const FIELDS_NAME = 'fields';
export const FUEL_TYPE_NAME = 'fuelType';
export const GEOLOCATION_NAME = 'geoLocationPosition';
export const INSPECTION_EXPIRY_NAME = 'inspectionExpiry';
export const INTERIOR_NAME = 'interior';
export const LATITUDE_NAME = 'lat';
export const LIGHT_NAME = 'light';
export const LOCALE_NAME = 'locale';
export const LONGITUDE_NAME = 'lng';
export const MAKE_FILTER_NAME = 'makesFilter';
export const MAKE_NAME = 'make';
export const MAX_MONTHLY_PRICE = 1000;
export const MAX_PRICE_VALUE = 150000;
export const METALLIC_NAME = 'metallic';
export const MILEAGE_RANGE_NAME = 'mileageRange';
export const MIN_MONTHLY_PRICE = 0;
export const MIN_PRICE_VALUE = 0;
export const MODEL_NAME = 'model';
export const MONTHLY_PRICE_RANGE_NAME = 'monthlyPriceRange';
export const MULTIMEDIA_NAME = 'multimedia';
export const PAGE_NAME = 'page';
export const PAGE_SIZE_NAME = 'pageSize';
export const PARKING_SENSORS_NAME = 'parkingSensors';
export const POWER_RANGE_NAME = 'powerRange';
export const POWER_TYPE_NAME = 'powerType';
export const PREV_OWNER_NAME = 'prevOwner';
export const PRICE_RANGE_NAME = 'priceRange';
export const PUBLISHED_NAME = 'published';
export const SEAT_COMFORT_NAME = 'seatComfort';
export const SEAT_RANGE_NAME = 'seatRange';
export const SECURITY_NAME = 'security';
export const SELLER_ID_NAME = 'sellerId';
export const SELLER_TYPE_NAME = 'sellerType';
export const SERVICE_HISTORY_NAME = 'serviceHistory';
export const SMOKER_NAME = 'smoker';
export const SORT_NAME = 'sort';
export const SUB_TYPE_NAME = 'subType';
export const TRANSMISSION_NAME = 'transmission';
export const UPHOLSTERY_NAME = 'upholstery';
export const VEHICLE_NAME = 'vehicle';
export const YEAR_RANGE_NAME = 'yearRange';
export const ZIPCODE_NAME = 'zipcode';
export const PRICE_TYPE_NAME = 'priceType';
export const HAS_IMAGES_NAME = 'hasImages';
